<app-contribution-setup [config]="config">
  <app-provider-sidebar></app-provider-sidebar>
</app-contribution-setup>
